import RouteURLs from 'RouteURLs';
import {generatePath} from 'react-router';
import {Booking, BookingSettings, DraftBooking} from 'services/entities/booking';
import {
  bookingCanCheckOut,
} from 'services/bookings';

export enum BookingStep {
  Time,
  AddOns,
  CheckOut,
  Success
}

export function getPreviousStep(step: BookingStep, booking: Booking|DraftBooking, settings: BookingSettings): BookingStep|null {
  const stepIndex = step as number;
  if(stepIndex === 0) {
    return null;
  }
  let prevStepIndex = stepIndex - 1;
  while(prevStepIndex >= 0) {
    if(stepIsAccessible(prevStepIndex, booking, settings)) {
      return prevStepIndex;
    }
    prevStepIndex--;
  }
  return null;
}

export function getNextStep(step: BookingStep, booking: Booking|DraftBooking, settings: BookingSettings): BookingStep|null {
  const stepIndex = step as number;
  if(stepIndex === BookingStep.Success) {
    return null;
  }
  let nextStepIndex = stepIndex + 1;
  while(nextStepIndex <= BookingStep.Success) {
    if(stepIsAccessible(nextStepIndex, booking, settings)) {
      return nextStepIndex;
    }
    nextStepIndex++;
  }
  return null;
}

export function stepIsAccessible(step: BookingStep, booking: Booking|DraftBooking, settings: BookingSettings): boolean {
  switch(step) {
    case BookingStep.Time:
      // only accessible before creation
      return !booking.code;
    case BookingStep.AddOns:
      /*if(!booking.code) {
        // new booking - can edit addons if time is set, and not within 7 days of booking
        return bookingCanCheckOut(booking) && bookingAddOnsAreEditable(booking, settings);
      } else {
        // existing booking - can edit if not within 7 days of booking
        return bookingAddOnsAreEditable(booking, settings);
      }*/
      return false;
    case BookingStep.CheckOut:
      // accessible if existing booking or time is set
      return !!booking.code || bookingCanCheckOut(booking);
    case BookingStep.Success:
      // only accessible for created bookings
      return !!booking.code;
  }
}

export function getStepURL(step: BookingStep, bookingCode: string|null|undefined = undefined) {
  switch(step) {
    default:
    case BookingStep.Time:
      return bookingCode ? generatePath(RouteURLs.EDIT_BOOKING_TIME, {code: bookingCode}) : RouteURLs.CREATE_BOOKING_TIME;
    case BookingStep.AddOns:
      return bookingCode ? generatePath(RouteURLs.EDIT_BOOKING_ADDONS, {code: bookingCode}) : RouteURLs.CREATE_BOOKING_ADDONS;
    case BookingStep.CheckOut:
      return bookingCode ? generatePath(RouteURLs.EDIT_BOOKING_CHECK_OUT, {code: bookingCode}) : RouteURLs.CREATE_BOOKING_CHECK_OUT;
    case BookingStep.Success:
      return bookingCode ? generatePath(RouteURLs.EDIT_BOOKING_SUCCESS, {code: bookingCode!}) : RouteURLs.CREATE_BOOKING_CHECK_OUT;
  }
}